﻿(function() {
    "use strict";

    angular.module("app").controller("BillingController", BillingController);

    BillingController.$inject = ["$scope", "$rootScope", "request", "$timeout", "constants", "pricingHelper", "$q", "modalTabHelper", "userApi"];

    function BillingController($scope, $rootScope, request, $timeout, constants, pricingHelper, $q, modalTabHelper, userApi) {
        let vm = this;

        vm.constants = constants;

        vm.$onInit = onInit;
        vm.scope = $scope

        vm.projects = undefined;
        vm.project = undefined;
        vm.sideBarProject = undefined;

        vm.filters = {
            projectType: {
                key: 'projectType',
                label: 'Project Type',
                all: true,
                values: [
                    { name: 'Project', value: 1, selected: true },
                    { name: 'Service Tickets', value: 2, selected: true },
                    { name: 'Maintenance', value: vm.constants.projectType.maintenance, selected: true }
                ]
            },
            scheduledStatus: {
                key: 'scheduledStatus',
                label: 'Status',
                all: true,
                values: [
                    { name: 'Unscheduled', value: 0, selected: true },
                    { name: 'Scheduled', value: 1, selected: true },
                    { name: 'Waiting on parts', value: 2, selected: true },
                    { name: 'Completed', value: 3, selected: true }
                ]
            },
            invoicedStatus: {
                key: 'invoicedStatus',
                label: 'Reviewed/Not-Reviewed',
                all: true,
                values: [
                    { name: 'Not-Reviewed', value: 0, selected: true },
                    { name: 'Reviewed', value: 1, selected: true },
                    { name: 'Completed Visits', value: 7, selected: true },
                    { name: 'Not Invoiced', value: 5, selected: true },
                    { name: 'Outstanding', value: 6, selected: true },
                    { name: 'Paid', value: 4, selected: true }
                ]
            },
            divisions: {
                key: 'divisions',
                label: 'Divisions',
                all: true,
                values: [

                ]
            }
        };

        vm.dateRangeFilter = {
            starting: null,
            ending: null
        }

        vm.loadProjects = loadProjects;
        vm.isRefreshing = false;
        vm.selectProject = selectProject;

        vm.updateFilter = updateFilter;

        vm.notificationDuration = 0
        vm.notificationType = ''
        vm.notificationMessage = ''
        vm.notificationOnClose = () => {
            vm.notificationMessage = ''
        }

        function showNotification(duration, type, message) {
            vm.notificationDuration = duration
            vm.notificationType = type
            vm.notificationMessage = message
            vm.notificationNonce = Math.random()
        }

        vm.costCode = {
            id: '',
            name: '',
            qboId: '',
            qboDisplayName: '',
            search: '',
            qboItems: [],
            qboItemsLoading: false
        };
        vm.customer = {
            id: '',
            name: '',
            qboId: '',
            qboDisplayName: '',
            search: '',
            qboItems: [],
            qboItemsLoading: false
        };
        
        vm.transformCustomerQboLinkData = transformCustomerQboLinkData;
        vm.customerLinkedInQbo = customerLinkedInQbo;
        vm.customerUnlinkedFromQbo = customerUnlinkedFromQbo;
        vm.createQboCustomer = createQboCustomer;

        $scope.$watch("vm.dateRangeFilter", function(newVal, oldVal) {
            if (newVal != oldVal)
                localStorage.setItem("billing_dateRangeFilter", angular.toJson(vm.dateRangeFilter));
        }, true);

        // used by push customer to QuickBooks when customer has multiple properties
        vm.initiatePushQboCustomerPromise = initiatePushQboCustomerPromise;
        vm.pushQboCustomerPropertySelected = pushQboCustomerPropertySelected;

        vm.notReviewedState = 1
        vm.reviewedState = 2

        localStorage.removeItem('new-invoicing-page')
        vm.showNewInvoicingPage = localStorage.getItem('use-classic-invoicing') !== 'true'
        vm.onNewPageToggle = function(useNewInvoicing) {
            vm.showNewInvoicingPage = useNewInvoicing;
            localStorage.setItem('use-classic-invoicing', useNewInvoicing ? 'false' : 'true')
            if (!$scope.$$phase && !$rootScope.$$phase) {
                $scope.$apply();
            }
        }

        function checkAuthorization() {
            userApi.getCurrentUser().then((data) => {
                if (!data.roles || !data.roles.includes("Accounting") || !data.permissionKeys || !data.permissionKeys.includes(constants.permissionKeys.allowInvoicing)) {
                    window.location.href = "/"
                }
            })
        }

        function onInit() {
            checkAuthorization()

            var savedDateRangeFilter = JSON.parse(localStorage.getItem("billing_dateRangeFilter"));
            if (savedDateRangeFilter) {
                vm.dateRangeFilter = savedDateRangeFilter;
            }

            request.get($rootScope.apiEndpoint + '/divisions/groups').then(response => {
                // get divisions from DB and toggled by local storage
                const savedDivisionsFilter = localStorage.getItem("invoicingFilter_divisions");
                vm.filters.divisions.values = response.data.map(g => {
                    return { name: g.groupName, value: g.groupName, selected: (savedDivisionsFilter == null) ? true : savedDivisionsFilter.includes(g.groupName) }
                });
                vm.filters.divisions.all = vm.filters.divisions.values.every(d => d.selected);
            });

            // toggle remaining filters by local storage
            toggleSavedFilters();

            // initialize pricing helper
            pricingHelper.init();

            loadProjects();

            modalTabHelper.init();
        }

        function toggleSavedFilters() {
            // invoiced status
            const savedInvoicedStatuses = localStorage.getItem("invoicingFilter_invoicedStatus");
            vm.filters.invoicedStatus.values.forEach(is => is.selected = (savedInvoicedStatuses == null) ? true : savedInvoicedStatuses.includes(is.value));
            vm.filters.invoicedStatus.all = vm.filters.invoicedStatus.values.every(d => d.selected);

            // scheduled status
            const savedScheduledStatus = localStorage.getItem("invoicingFilter_scheduledStatus");
            vm.filters.scheduledStatus.values.forEach(is => is.selected = (savedScheduledStatus == null) ? true : savedScheduledStatus.includes(is.value));
            vm.filters.scheduledStatus.all = vm.filters.scheduledStatus.values.every(d => d.selected);

            // project type
            const savedProjectType = localStorage.getItem("invoicingFilter_projectType");
            vm.filters.projectType.values.forEach(is => is.selected = (savedProjectType == null) ? true : savedProjectType.includes(is.value));
            vm.filters.projectType.all = vm.filters.projectType.values.every(d => d.selected);
        }

        function loadProjects() {
            var url = '/billing/projects';

            if (vm.dateRangeFilter.starting && vm.dateRangeFilter.ending) {
                url += '?startDate=' + moment(vm.dateRangeFilter.starting, 'MM/DD/YYYY').toISOString() +
                    '&endDate=' + moment(vm.dateRangeFilter.ending, 'MM/DD/YYYY').toISOString()
            }

            if (vm.projects)
                vm.isRefreshing = true;

            request.get($rootScope.apiEndpoint + url).then(response => {
                vm.projects = response.data;

                vm.isRefreshing = false;

                $timeout(() => {
                    applySidebarFilters();

                    if (vm.project) {
                        vm.preventReloadingProject = true;
                        vm.sidebarElements.selectElementByCallback(elem => elem.id === vm.project.id);
                    }
                });
            }, function(error) {
                vm.isRefreshing = false;
                showNotification(5, 'Error', "Could not load projects")
            });
        }

        function selectProject(element) {
            if (vm.preventReloadingProject) {
                vm.preventReloadingProject = false;
                return;
            }

            vm.sideBarProject = element;

            loadProject();
        }

        function loadProject() {
            vm.itemsContextSaveCounter++
            request.get(`${$rootScope.apiEndpoint}/jobs/${vm.sideBarProject.id}`).then(response => {
                vm.project = response.data;

                vm.project.workareas.forEach((workarea, index) => {
                    workarea.scheduleDate = moment(workarea.scheduleDate).isValid() ? moment(workarea.scheduleDate).format("MM/DD/YYYY") : null;
                });

                vm.budgetsForItemTable = pricingHelper.getBudgetsForYear(vm.project.budgetYear)

                // setup project view model
                switch (vm.project.type) {
                    case vm.constants.projectType.project:
                        vm.project.typeName = "Project";
                        vm.project.workareaFieldName = "Workarea"
                        vm.project.icon = "fa-archive";
                        vm.project.url = 'projects/' + vm.project.url
                        break;
                    case vm.constants.projectType.ticket:
                        vm.project.typeName = "Service Ticket";
                        vm.project.workareaFieldName = "Task"
                        vm.project.icon = "fa-fire";
                        vm.project.url = 'tickets/' + vm.project.url
                        break;
                    case vm.constants.projectType.maintenance:
                        vm.project.typeName = "Maintenance";
                        vm.project.workareaFieldName = "Task"
                        vm.project.icon = "fa-toolbox";
                        vm.project.url = 'maintenance/' + vm.project.url
                        break;
                }
            }).catch(error => {
                const jobLoadError = (error.data && error.data.message) ? error.data.message : 'There was an error loading the selected job.'
                showNotification(5, 'Error', jobLoadError)
            });
        }

        function updateFilter(filterName, toggle = false) {
            var filter = vm.filters[filterName];

            if (toggle) {
                filter.values.forEach(f => f.selected = filter.all);
            }

            filter.all = filter.values.every(f => f.selected);

            // keep filters in local storage
            localStorage.setItem("invoicingFilter_" + filter.key, filter.values.filter(d => d.selected).map(d => d.value));

            applySidebarFilters();
        }

        vm.filterCounter = 0
        vm.onFilterChange = function onFilterChange(filterName, selectedValues) {
          vm.filters[filterName].values.forEach(f => f.selected = selectedValues.includes(f.value));
          vm.filters[filterName].all = vm.filters[filterName].values.every(d => d.selected);

          applySidebarFilters();
          $scope.$apply();
          vm.filterCounter++
        }

        vm.onDateRangeChange = function onDateRangeChange(startDate, endDate) {
          vm.dateRangeFilter.starting = startDate;
          vm.dateRangeFilter.ending = endDate;
          loadProjects();
        }

        function getFilters(filterName) {
            return vm.filters[filterName].values.filter(p => p.selected).map(p => p.value);
        }

        function applySidebarFilters() {
            vm.sidebarElements.elements.forEach(e => {
                e.visible = true;
                if (!vm.filters.projectType.all) {
                    var values = getFilters('projectType');

                    e.visible = e.visible && values.indexOf(e.type) >= 0;
                }
                if (!vm.filters.scheduledStatus.all) {
                    var values = getFilters('scheduledStatus');

                    if (e.type != vm.constants.projectType.project && e.taskStatuses) {
                        e.visible = e.visible && (values.indexOf(e.status) >= 0 || values.some(x => e.taskStatuses.some(y => y == x)))
                    } else {
                        e.visible = e.visible && values.indexOf(e.status) >= 0;
                    }
                }
                if (!vm.filters.divisions.all) {
                    var values = getFilters('divisions');

                    e.visible = e.visible && e.divisionGroups.some(d => values.indexOf(d) >= 0);
                }
                if (!vm.filters.invoicedStatus.all) {
                    var values = getFilters('invoicedStatus');

                    e.visible = e.visible && (
                        values.indexOf(0) >= 0 && e.isNotReviewed ||
                        values.indexOf(1) >= 0 && e.isReviewed ||
                        values.indexOf(2) >= 0 && e.isUninvoiced ||
                        values.indexOf(3) >= 0 && e.isInvoiced ||
                        values.indexOf(4) >= 0 && e.isPaid ||
                        values.indexOf(5) >= 0 && e.isNotInvoiced ||
                        values.indexOf(6) >= 0 && e.isOutstanding ||
                        values.indexOf(7) >= 0 && e.hasCompletedVisits);

                }
            });

        }

        // function used by the link-qbo-entity component
        // to transform the data which is posted to the update endpoint [to update the qboId property in the db]
        function transformCustomerQboLinkData(data) {
            return { id: vm.project.customer.id, qboId: data.id, qboDisplayName: data.displayName };
        }

        // function called after the customer has been successfully linked from the link-qbo-entity component
        // to update the view model
        function customerLinkedInQbo(data) {
            vm.project.customer.qboId = data.qboId;
            vm.project.customer.qboDisplayName = data.qboDisplayName;
        }

        // function called after the customer has been successfully unlinked from the link-qbo-entity component
        // to update the view model
        function customerUnlinkedFromQbo() {
            vm.project.customer.qboId = null;
            vm.project.customer.qboDisplayName = null;
        }

        vm.onInvoicesChanged = function() {
            loadProject();
            setTimeout(() => {
                vm.itemsContextSaveCounter++
                $scope.$emit("form-cleaned")
                $scope.$apply()
            }, 0)
        }

        /* used when the QuickBooks linking pop is opened
         * initiates the linking promise to the QuickBooks component
         */
        function initiatePushQboCustomerPromise() {
            vm.pushQboCustomerDefer = $q.defer();
        }

        /* used when pushing customer to QBO, ONLY IF the customer has multiple properties
         * this is used to allow user to select target property
         */
        function pushQboCustomerPropertySelected() {
            vm.isPushQboCustomerPropertySelected = true;
            createQboCustomer();
        }

        /* function called when creating QuickBooks customer from Synked customer
         */
        function createQboCustomer() {
            var apiUrl = `/quickbooks/customer?id=${vm.project.customer.id}`;

            // if customer has more properties, override method to first select the target property
            if (vm.project.customer.properties > 1) {
                if (!vm.isPushQboCustomerPropertySelected) {
                    $(".modal").modal("hide");
                    vm.selectedPushQboCustomerProperty = vm.project.customer.propertyList[0];
                    $("#select-property-qbo-create-customer").modal();

                    // return unresolved promise, to allow user select the customer property
                    return vm.pushQboCustomerDefer.promise;
                }
                else {
                    // if target property was selected, add to apiUrl as param
                    apiUrl += vm.selectedPushQboCustomerProperty ? `&selectedPropertyId=${vm.selectedPushQboCustomerProperty.id}` : '';
                }
            }

            // finally, push the customer to QBO
            request.post($rootScope.apiEndpoint + apiUrl).then(function(result) {
                vm.project.customer.qboId = result.data.entity.id;
                vm.project.customer.qboDisplayName = result.data.entity.displayName;
                vm.isPushQboCustomerPropertySelected = false;
                vm.pushQboCustomerDefer.resolve({ id: vm.project.customer.id, qboId: result.data.entity.id, qboDisplayName: result.data.entity.displayName });

            }, function(e) {
                vm.isPushQboCustomerPropertySelected = false;
                vm.pushQboCustomerDefer.reject(e);
            });

            if (vm.pushQboCustomerDefer) {
                return vm.pushQboCustomerDefer.promise
            } else {
                return
            }
        }

        vm.linkCustomerToQbo2 = () => {
            openCustomerLinkQboModal(false)
        }

        function openCustomerLinkQboModal() {
            $timeout(function() {
                document.getElementsByClassName('link-qbocustomer')[0].click()
            });
        }

        vm.linkCostCodeToQbo2 = (costCodeId) => {
            openSetupLinkCostCode(costCodeId, false)
        }

        function openSetupLinkCostCode(costCodeId) {
            vm.selectedQboCostCodeToLink = costCodeId;
            vm.linkQboEntity.show();
        }
      
        vm.reactCostCodeRefreshCounter = 0
        vm.linkQboCostCode = linkQboCostCode

        function linkQboCostCode(data, updateDetails) {
            var costCode = updateDetails ? { id: vm.selectedQboCostCodeToLink, qboId: data.id, qboDisplayName: data.displayName } : { id: vm.selectedQboCostCodeToLink, qboId: data.id }
            request.post($rootScope.apiEndpoint + "/costcodes/qbo", costCode).then(function() {
                vm.reactCostCodeRefreshCounter++
            }, function(e) {
                showNotification(5, 'Error', "Failed to link cost code to QuickBooks")
            });
        }

        vm.itemsContextSaveCounter = 0
        vm.itemsContextFocusedView = 'visits'

        vm.templateAddedFromItemTable = function templateAddedFromItemTable(workareaId, template) {
        }

        vm.onItemsContextChange = function onItemsContextChange(changeSet, visitSummary, workareaSummaries) {
        }

        vm.editVisit = function editVisit(visitId) {
            vm.showVisitModal = true;
            vm.editVisitId = visitId;
            $scope.$apply()
        }

        vm.closeVisitModal = function closeVisitModal() {
            vm.showVisitModal = false;
            loadProject();
            $scope.$apply()
        }
    }
})();
